import React from 'utils/react';
import useTranslation from 'utils/react/useTranslation';
import { Modal, ModalHeader, ModalBody } from 'baseui/modal';

import debug from 'utils/debug';
import MethodBtn from './MethodBtn';
import manual from 'assets/manual.svg';
import auto from 'assets/autoAssign.svg';
import { useStyletron } from 'baseui';
import { useEffect, useState } from 'react';

const D2 = debug('c:ModalWindows:MethodWindow');

export default function MethodWindow(props) {
  D2.S.INFO('MethodWindow', props);
  const [css] = useStyletron('');
  const [options, setOptions] = useState({});
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);
  const { hasOnlineVehicles } = props;

  React.useEffect(() => {
    window.openMethodWindow = (opts) => {
      setOptions(opts || {});
      setIsOpen(true);
    };
    window.closeMethodWindow = () => {
      setIsOpen(false);
    };
    return () => {
      window.MethodWindow = null;
    };
  });

  function onClose() {
    setIsOpen(false);
  }

  return (
    <React.Fragment>
      <Modal
        onClose={onClose}
        isOpen={isOpen}
        overrides={{
          Dialog: {
            style: {
              width: '648px',
            },
          },
        }}
      >
        <ModalHeader
          className={css({
            color: '#fff',
            fontFamily: 'Montserrat !important',
            fontSize: '24px',
            fontWeight: '700 !important',
            marginTop: '10px !important',
          })}
          data-testid='MethodWindow-Header'
        >
          {t('c.ModalWindow.ChooseMethod.Title')}
        </ModalHeader>
        <ModalBody data-testid='MethodWindow-Body'>
          <MethodBtn
            img={manual}
            title={t('c.ModalWindow.ChooseMethod.button.manual.title')}
            description={t(
              'c.ModalWindow.ChooseMethod.button.manual.description'
            )}
            onClick={() => {
              options.manualAction();
              setIsOpen(false);
            }}
          />
          <MethodBtn
            overrides={{
              Body: {
                props: {
                  'data-testid': 'StatefulPopover-Body',
                },
              },
              Arrow: {
                props: {
                  'data-testid': 'StatefulPopover-Arrow',
                },
              },
              Inner: {
                props: {
                  'data-testid': 'StatefulPopover-Inner',
                },
              },
            }}
            img={auto}
            title={t('c.ModalWindow.ChooseMethod.button.auto.title')}
            description={t(
              'c.ModalWindow.ChooseMethod.button.auto.description'
            )}
            onClick={() => {
              setIsOpen(false);
              global.openWarningMessage({
                title: t('c.ModalWindow.AutoAssignment.modal.title'),
                message: (
                  <>
                    {t('c.ModalWindow.AutoAssignment.modal.message', {
                      count: options?.vehicleStats?.unlockedVehicles,
                      total: options?.vehicleStats?.totalVehicles,
                    })}
                    <br />
                    <br />
                    <b>{t('c.ModalWindow.AutoAssignment.modal.warning')}</b>
                  </>
                ),
                buttons: [
                  {
                    text: t('c.messages.Cancel'),
                    fill: false,
                  },
                  {
                    text: t('c.ModalWindow.AutoAssignment.modal.button'),
                    action: () => {
                      options.autoAction();
                      global.closeWarningMessage();
                    },
                    fill: true,
                  },
                ],
              });
            }}
            disabled={hasOnlineVehicles}
          />
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}

window.openMethodWindow = () => {};
window.closeMethodWindow = () => {};
